<template>
  <table class="table">
    <thead>
      <slot name="columns">
        <tr>
          <th v-for="column in columns" :key="column">{{column}}</th>
          <th><vs-checkbox v-model="selectAll"></vs-checkbox></th>
        </tr>
      </slot>
    </thead>
    <tbody>
    <tr v-for="(item, index) in data" :key="index">
      <slot :row="item">
        <td :class="{'word-break-cell': column=='Cliente'}" v-for="column in columns" :key="column" v-if="hasValue(item, column)">{{itemValue(item, column)}}</td>
        <td style="align-items: center;">
          <vs-checkbox v-model="selectTickets" :vs-value="item" ></vs-checkbox>
        </td>
      </slot>
    </tr>
    </tbody>
  </table>
</template>
<script>
  export default {
    name: 'l-table2',
    props: {
      columns: Array,
      data: Array
    },
    data(){
      return{
        selectAll:false,
        selectTickets:[],
      }
    },
    methods: {
      hasValue (item, column) {
        return item[column.toLowerCase()] !== 'undefined'
      },
      itemValue (item, column) {
        return item[column.toLowerCase()]
      },
      functionComponentDelete(item){
        this.$emit('functionComponentDelete', item);
      },
      functionComponentEdit(item){
        this.$emit('functionComponentEdit', item);
      },
      selectTicketsReload(){
        this.selectTickets=[];
      },
    },
    watch: {
      selectAll: function(val) {
        if(val)this.selectTickets=this.data;
        else {
          if(this.selectTickets==this.data)this.selectTickets=[];
        } 
        this.$emit('selectTickets', this.selectTickets);
      },
      selectTickets: function() {
        if(this.selectTickets==this.data)this.selectAll=true;
        if(this.selectTickets!=this.data)this.selectAll=false;
        this.$emit('selectTickets', this.selectTickets);
      }
    }
  }
</script>
<style>
  .word-break-cell {
    word-break: break-all!important;
  }
</style>
